export type OpenSNLocalizedText = string | Record<string, string>;

export type OpenSNFieldOption = {
  value: string;
  label: OpenSNLocalizedText;
  description?: OpenSNLocalizedText;
};

export type OpenSNFieldVisibility = {
  field: string;
  equals: string | string[];
};

export type OpenSNFieldKind = "text" | "email" | "textarea" | "select" | "multiselect" | "choice";

export type OpenSNMemberField = {
  id: string;
  name: string;
  label: OpenSNLocalizedText;
  kind: OpenSNFieldKind;
  required?: boolean;
  placeholder?: OpenSNLocalizedText;
  autocomplete?: string;
  minLength?: number;
  maxLength?: number;
  defaultValue?: string | string[];
  options?: OpenSNFieldOption[];
  visibleWhen?: OpenSNFieldVisibility;
};

export type OpenSNMemberSection = {
  id: string;
  label: OpenSNLocalizedText;
  fields: OpenSNMemberField[];
};

export type OpenSNRelationshipType = {
  id: string;
  label: OpenSNLocalizedText;
  actionLabel?: OpenSNLocalizedText;
  successLabel?: OpenSNLocalizedText;
  titleMode: "none" | "optional" | "required";
  titleLabel?: OpenSNLocalizedText;
  defaultTitle?: OpenSNLocalizedText;
  titleOptions?: OpenSNFieldOption[];
  reciprocal?: boolean;
};

export type OpenSNSocialDefinition = {
  version: number;
  member: {
    label: OpenSNLocalizedText;
    signup: {
      displayNameLabel?: OpenSNLocalizedText;
      displayNamePlaceholder?: OpenSNLocalizedText;
      fields: OpenSNMemberField[];
    };
    profile: {
      sections: OpenSNMemberSection[];
    };
  };
  relationships: {
    defaultType: string;
    types: OpenSNRelationshipType[];
  };
};

export function defineOpenSNSocialDefinition(definition: OpenSNSocialDefinition): OpenSNSocialDefinition {
  return definition;
}

export function localizeOpenSNText(text: OpenSNLocalizedText | undefined, localeCode: string, fallback = ""): string {
  if (typeof text === "string") return text.trim() || fallback;
  if (!text) return fallback;
  const locale = localeCode.toLocaleLowerCase();
  const shortLocale = locale.split("-")[0] ?? locale;
  return String(text[locale] ?? text[shortLocale] ?? text.en ?? Object.values(text)[0] ?? fallback).trim() || fallback;
}
